var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31,
    r: 31,
    fill: "#ed771f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2962 23.0468C39.666 22.6947 40.1581 22.5001 40.6686 22.504C41.1792 22.5078 41.6682 22.7099 42.0327 23.0675C42.3971 23.4251 42.6083 23.9102 42.6218 24.4206C42.6353 24.931 42.45 25.4267 42.105 25.803L31.6312 38.9018C31.4511 39.0957 31.2338 39.2514 30.9921 39.3595C30.7505 39.4675 30.4895 39.5258 30.2249 39.5307C29.9602 39.5356 29.6973 39.487 29.4518 39.388C29.2064 39.289 28.9834 39.1414 28.7962 38.9543L21.8505 32.0085C21.6571 31.8283 21.5019 31.6109 21.3943 31.3694C21.2867 31.1279 21.2288 30.8672 21.2242 30.6029C21.2195 30.3385 21.2681 30.076 21.3672 29.8308C21.4662 29.5857 21.6136 29.363 21.8005 29.176C21.9875 28.9891 22.2101 28.8417 22.4553 28.7427C22.7004 28.6437 22.963 28.595 23.2274 28.5997C23.4917 28.6044 23.7524 28.6622 23.9939 28.7698C24.2354 28.8774 24.4527 29.0326 24.633 29.226L30.1297 34.7201L39.2464 23.1045L39.2962 23.0468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupChecked);
export default __webpack_public_path__ + "static/media/popup-checked.6b730b8cd6b7129da70fb6bdc4ba4201.svg";
export { ForwardRef as ReactComponent };